import { render, staticRenderFns } from "./examresultslist.vue?vue&type=template&id=4669b220&scoped=true"
import script from "./examresultslist.vue?vue&type=script&lang=js"
export * from "./examresultslist.vue?vue&type=script&lang=js"
import style0 from "./examresultslist.vue?vue&type=style&index=0&id=4669b220&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4669b220",
  null
  
)

export default component.exports